import { createContext, useContext, useMemo, useState } from 'react'
import axios from 'axios'

interface Auth {
  isAuthenticated: boolean
  setIsAuthenticated: (isAuthenticated: boolean) => void
  login: () => void
  logout: () => Promise<void>
}

const AuthContext = createContext<Auth>({
  isAuthenticated: undefined,
  setIsAuthenticated: undefined,
  login: () => undefined,
  logout: () => undefined
})

export default AuthContext

const useAuth = () => useContext(AuthContext)

const client = axios.create()

const login = () => {
  window.location.href = '/api/auth/line/login'
}

const logout = async () => {
  liff.ready.then(() => liff.logout()) // intentionally parallel to fetch()
  const { data } = await client.post<{ success: boolean }>('/api/auth/logout', null, {
    withCredentials: true
  })

  const { success } = data
  if (success) {
    window.location.href = '/'
  }
}

const useProvideAuth = (initAuth = false): Auth => {
  const [isAuthenticated, setIsAuthenticated] = useState(initAuth)
  return useMemo(() => ({ isAuthenticated, setIsAuthenticated, login, logout }), [isAuthenticated])
}

export { useProvideAuth, useAuth }
